import { getRandomAlphaNumericString } from 'utils/general/getRandomAlphaNumericString'

export const generateEmployeeId = (orgName: string, name: string): string => {
  if (!orgName || !name) {
    throw new Error('orgName and name are required')
  }

  const transformedName = name?.replace(/\s/g, '_')

  const randomString = getRandomAlphaNumericString(-6)

  return `${orgName}_${transformedName}_${randomString}`.toLowerCase()
}
